import React from "react";
import User from "../../api/User";

export const ListOptionRole = ({ className }) => {
  const selectRole = (e) => {
    if (e.target.selectedIndex !== 0) {
      User.setUserRole(e.target.value);
    }
  };

  const selectClassName = className
    ? className
    : "site-form-control site-form-select";

  return (
    <select
      className={selectClassName}
      onChange={selectRole}
      aria-label="Роль сотрудника"
    >
      <option>Выберите роль</option>
      {User.all_role !== undefined ? (
        User.all_role.map((role) => (
          <option role={role} key={role.id} value={role.id}>
            {role.role_name}
          </option>
        ))
      ) : (
        <></>
      )}
    </select>
  );
};
